import React, { useState } from 'react';

import ItemVideo from './itemVideo/itemVideo';
import { PlayerPopup, ButtonLightRed } from '../../../components';
import classes from './sectionPlayVideos.module.css';

const SectionPlayVideos = props => {
  const [showVideo, setShowVideo] = useState(false);
  const [source, setSource] = useState('');

  const openPlayer = (open, path) => {
    setSource(`${process.env.REACT_APP_VIDEOS_CDN_URL}${path}`)
    setShowVideo(open)
  }

  return (
    <div>
      {
        showVideo &&
        <PlayerPopup
          close={() => openPlayer(false)}
          show={showVideo}
          source={source}
        />
      }

      <div className={classes.generalContent}>
        <a id="quees"></a>
        <div className={classes.contentVideos}>
          <div className={classes.header}>
            <h1 className="main-text">¿Quieres saber más?</h1>
            <p className="desc-text">Aprende cómo registrarse y realizar cada movimiento <br /> con estás guías rápidas.</p>
          </div>

          <div className={classes.videosGrid}>
            {/* <ItemVideo
              image="register"
              title="¿Cómo registrarse?"
              textButton="Ver video"
              onClick={() => openPlayer(true, '/registrar/ComoRegistrarse.mp4')}
            /> */}
            <ItemVideo
              image="addMoneyTransfer"
              title="Agrega dinero"
              subtitle="con una transferencia"
              textButton="Ver video"
              onClick={() => openPlayer(true, '/Dinero/agregarDineroTransferencia.mp4')}
            />
            {/* <ItemVideo
              image="addMoneyCard"
              title="Agrega dinero"
              subtitle="con una tarjeta"
              textButton="Ver video"
              onClick={() => openPlayer(true, '/tarjeta/agregarDineroTarjeta.mp4')}
            /> */}
            {/* <ItemVideo
              image="addMoneyStore"
              title="Agrega dinero en Inbursa "
              titleSecondLine="y tiendas participantes"
              textButton="Ver video"
              onClick={() => openPlayer(true, '/comercios/AgregarDineroEnInbursaComercios.mp4')}
            /> */}
            {/* <ItemVideo
              image="addMoneyAccount"
              title="Agrega dinero asociando"
              titleSecondLine=" una cuenta Inbursa"
              textButton="Ver video"
              onClick={() => openPlayer(true, '/Dinero/AgregarDineroAsociandoCuenta.mp4')}
            /> */}
            <ItemVideo
              image="addPaymentMethod"
              title="Agrega una tarjeta para hacer"
              titleSecondLine="pagos dentro de Claro Pay"
              textButton="Ver video"
              onClick={() => openPlayer(true, '/tarjeta/AgregarTarjetaParaPagar.mp4')}
            />
            <ItemVideo
              image="consultaSaldo"
              title="Consulta tu saldo"
              textButton="Ver video"
              onClick={() => openPlayer(true, '/consulta/consultaSaldoWeb.mp4')}
            />
            {props.size === 'large' &&
              (
                <>
                  <ItemVideo
                    image="envioDinero"
                    title="Envía dinero"
                    textButton="Ver video"
                    onClick={() => openPlayer(true, '/Dinero/enviarDineroweb.mp4')}
                  />
                  <ItemVideo
                    image="servicios"
                    title="Paga los servicios"
                    textButton="Ver video"
                    onClick={() => openPlayer(true, '/servicios/pagarServiciosWeb.mp4')}
                  />
                  <ItemVideo
                    image="pagoComercios"
                    title="Paga en comercios"
                    textButton="Ver video"
                    onClick={() => openPlayer(true, '/comercios/pagarComerciosWeb.mp4')}
                  />
                  <ItemVideo
                    image="recarga"
                    title="Recarga tiempo aire"
                    textButton="Ver video"
                    onClick={() => openPlayer(true, '/TiempoAire/recargatiempoaireWeb.mp4')}
                  />
                  <ItemVideo
                    image="retiro"
                    title="Retira dinero"
                    textButton="Ver video"
                    onClick={() => openPlayer(true, '/Dinero/retirarDinero.mp4')}
                  />
                  <ItemVideo
                    image="paquetes"
                    title="Paquetes telcel"
                    textButton="Ver video"
                    onClick={() => openPlayer(true, '/PaqueteTelcel/paqueteTelcelWeb.mp4')}
                  />
                </>
              )
            }

          </div>
          <div className={classes.sectionBottom}>
            <ButtonLightRed onClick={props.onClickBtnShow}>{props.size === 'short' ? 'Ver todos los tutoriales' : 'Ver menos'}</ButtonLightRed>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SectionPlayVideos;
